export const calculateAPR = (idiaPrice: number, totalStakedPool: number, rewardPerSecond: number) => {
  const yearlyRewards = idiaPrice * (rewardPerSecond * 60 * 60 * 24 * 365) // yearly calc
  const potentialRewards = yearlyRewards / totalStakedPool // yearly/staked*100
  return potentialRewards * 100 // potential/total*100
}

export default null
